var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"12"}},[_c('b-alert',{staticClass:"status-icon-alert border-pill px-4 py-2 mb-3 w-sm-100 text-center fs-14 d-lg-inline-block",attrs:{"show":true,"variant":"danger"}},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }